import React, { useState } from 'react';

const WhatsAppWidget = ({ phoneNumber = '60123456789', message = 'Hello! I would like to know more about your services.' }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
        const encodedMessage = encodeURIComponent(message);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div 
            className="whatsapp-widget"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {isHovered && (
                <div className="whatsapp-widget__tooltip">
                    Chat with us!
                </div>
            )}
            <button 
                className="whatsapp-widget__button"
                onClick={handleClick}
                aria-label="Chat on WhatsApp"
            >
                <svg 
                    viewBox="0 0 32 32" 
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M16.002 0C7.175 0 0 7.175 0 16.002c0 2.822.736 5.574 2.137 8.004L.072 32l8.227-2.065a15.93 15.93 0 007.703 1.967C24.829 31.902 32 24.727 32 16.002 32 7.175 24.829 0 16.002 0zm0 29.332c-2.597 0-5.144-.7-7.37-2.024l-.528-.313-4.885 1.227 1.248-4.623-.343-.548a13.285 13.285 0 01-2.054-7.049c0-7.346 5.986-13.332 13.332-13.332 7.346 0 13.33 5.986 13.33 13.332 0 7.344-5.984 13.33-13.33 13.33zm7.327-9.987c-.4-.2-2.367-1.167-2.733-1.3-.367-.133-.633-.2-.9.2-.267.4-1.033 1.3-1.267 1.567-.233.267-.467.3-.867.1-.4-.2-1.687-.622-3.213-1.982-1.188-1.06-1.99-2.37-2.223-2.77-.233-.4-.025-.617.175-.817.18-.18.4-.467.6-.7.2-.233.267-.4.4-.667.133-.267.067-.5-.033-.7-.1-.2-.9-2.167-1.233-2.967-.325-.78-.655-.675-.9-.687-.233-.012-.5-.015-.767-.015s-.7.1-1.067.5c-.367.4-1.4 1.367-1.4 3.333 0 1.967 1.433 3.867 1.633 4.133.2.267 2.82 4.307 6.833 6.033.955.412 1.7.658 2.28.842.958.305 1.83.262 2.52.159.769-.115 2.367-.967 2.7-1.9.333-.933.333-1.733.233-1.9-.1-.167-.367-.267-.767-.467z"/>
                </svg>
            </button>
        </div>
    );
};

export default WhatsAppWidget;
